/**
 * 商品清单
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2020/10/10      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React,{Fragment } from 'react'
import { Popover ,Tag,Row} from "antd";
import dayjs from "dayjs";
import "./index.less";
import {
    toFixedWithCommas,
    numberWithCommas,
} from "../../../../../utils/number-util";
import PicturePreview from '@components/PicturePreview/PicturePreview';
import FulfillmentIcon from '@components/Icon/FulfillmentIcon';
import KizCodeIcon from '@components/Icon/KizCodeIcon';
import {isEmptyObject} from '@utils/utils';
import Lang from "@/components/Lang/Lang";
import FulfillmentDisplay from "@/components/Fullfilment/FulfillmentDisplay/index";
class List extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: props.list || [],
        };
    }
    refresh(){
        if(this.props.refreshList){
            this.props.refreshList()
        }
    }
    getItemList(list=[],model={}, type='',expandSixPicture,showCancleRemark){
        let children = [];
        list.forEach((item,index)=>{
            children.push(<tr key={index}>
                <td colSpan={5} >
                    <div className={'column-tr'}>
                        <div className={'pro-pic'}>
                            <div className="img-wrap">
                                <Popover
                                    placement="right"
                                    trigger="click"
                                    arrow={true}
                                    content={
                                        <img
                                            src={
                                                item.skuFileUrl +
                                                "@!200"
                                            }
                                            style={{
                                                width: "200px",
                                                height: "200px",
                                            }}
                                            alt=""
                                        />
                                    }
                                >
                                    <img
                                        src={item.skuFileUrl + "@!100"}
                                        className="img"
                                        alt=""
                                    />
                                </Popover>
                            </div> 
                            {isEmptyObject(item.requireResultVO)?null:<div className={"mb_4 text-center"} style={{height:"24px"}}><FulfillmentIcon /></div>}
                            {/* needKizCode  0:不需要 1:需要  则展示kiz图标 */}
                            {item.kizFlagVO&&item.kizFlagVO.needKizCode==1?<div className={"mb_4 text-center"} style={{height:"24px"}}> <KizCodeIcon /></div>:null}
                            {item.kizFlagVO&&item.kizFlagVO.kizStatus?<div className={`text-center fw_700 mt_2${item.kizFlagVO.kizStatus=='10'?" color_FB7321":" color-green2"}`}>
                                {item.kizFlagVO.kizStatusName}</div>:null}

                        </div>
                        <div className={'info'}>
                            <table className={'pro-info'}>
                                <tbody>
                                <tr>
                                    <td>
                                        <div className="flex">
                                            <div className="content">
                                                <p className="name">{item.skuName}</p>
                                                <p className="num">
                                                    {item.brandName} | {item.skuNo}
                                                    {item.skuHsNo
                                                        ? `(${item.skuHsNo})`
                                                        : ""}
                                                </p>
                                                <div className="relative">
                                                    <ul className="attr-wrap attr-wrap1">
                                                        <li>{__getServerLanguage('WaiXiangZhuangLiang')}: {item.skuCapacity}{__getServerDictItem("unit_type." + item.skuUnit)}/{__getServerDictItem("prd_goods_out_box_unit." + item.spuOutBoxUnit)||'-'}</li>
                                                        <li>{__getServerLanguage('TiJi')}: {toFixedWithCommas(item.skuOutBoxVolume,3)||'-'}m³</li>
                                                        <li>{__getServerLanguage('MaoJingZhong')}(kg):  {item.skuGrossWeight||'-'} / {item.skuNetWeight||'-'}</li>
                                                        <li>{__getServerLanguage('CaiZhi')}: {item.material||'-'}</li>
                                                        <li style={{width:'100%'}}>{__getServerLanguage('WaiXiangChiCun2')}: {item.skuOutBoxLength||'-'} * {item.skuOutBoxWidth||'-'} * {item.skuOutBoxHeight||'-'} cm</li>
                                                        <li style={{width:'100%'}}>{__getServerLanguage('ZhengShu')}:  {item.certificationName||'-'}</li>
                                                    </ul>


                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className={'widthPrice'}>
                                        {item.poItemTypeVal}
                                        {
                                            type=='cancel'?
                                                <ul className="attr-wrap margin-top-15">
                                                    <li>{__getServerLanguage('QuXiaoShiJian')}</li>
                                                    <li>{item.cancelTime?dayjs(item.cancelTime).format('YYYY-MM-DD HH:mm:ss'):''}</li>
                                                    {/* 取消原因 */}
                                                    {item.cancelMsg&&item.cancelMsg.length>0&&<Fragment>
                                                        <li className={'margin-top-5'}>{Lang({ id: "QuXiaoShuoMing", children: "取消说明" })}</li>
                                                        <li>{item.cancelMsg.map((str,i)=><span>{(i>0?';':'')+str}</span>)}</li>
                                                    </Fragment> }

                                                </ul>
                                                :
                                                <ul className="attr-wrap margin-top-15">
                                                    <li>{__getServerLanguage('XiaDanShiJian')}</li>
                                                    <li>{item.orderTime?dayjs(item.orderTime).format('YYYY-MM-DD HH:mm:ss'):''}</li>
                                                </ul>
                                        }
                                    </td>
                                    <td className={'widthNum'}>
                                        <div>
                                        <b>
                                            {model.currencySymbol}{" "}
                                            {numberWithCommas(
                                                toFixedWithCommas(item.price, 2)
                                            )}
                                        </b>
                                        {type !== "cancel" &&
                                        item.discountBeforePrice ? (
                                            <p className="util-del">
                                                {model.currencySymbol}{" "}
                                                {numberWithCommas(
                                                    toFixedWithCommas(
                                                        item.priceOld,
                                                        2
                                                    )
                                                )}
                                            </p>
                                        ) : null}
                                    </div></td>
                                    <td className={'widthBoxNum'}> <b>
                                        {type === "cancel"
                                            ? item.cancelQuantity
                                            : item.deliveryQuantity}
                                    </b>
                                    </td>
                                    <td className={'widthTotal'}>

                                            <b>
                                                {model.currencySymbol} {type === "cancel"
                                                ? numberWithCommas(
                                                    toFixedWithCommas(
                                                        item.cancelPriceTotal,
                                                        2
                                                    )
                                                )
                                                : numberWithCommas(
                                                    toFixedWithCommas(
                                                        item.priceTotal,
                                                        2
                                                    )
                                                )}
                                            </b>
                                            {type !== "cancel" &&
                                            item.discountBeforePrice ? (
                                                <p className="util-del">
                                                    {model.currencySymbol}{" "}
                                                    {numberWithCommas(
                                                        toFixedWithCommas(
                                                            item.discountBeforePrice,
                                                            2
                                                        )
                                                    )}
                                                </p>
                                            ) : null}
                                            {type !== "cancel" &&
                                            item.ddpTaxesCost ? (
                                                <ul
                                                    className="attr-wrap"
                                                >
                                                    <li>
                                                        {__getServerLanguage(
                                                            "NZengZhiShuiE",
                                                            item.importTariffRate
                                                        )}
                                                        ：{model.currencySymbol}{" "}
                                                        {numberWithCommas(
                                                            toFixedWithCommas(
                                                                item.ddpTaxesCost,
                                                                2
                                                            )
                                                        )}
                                                    </li>
                                                </ul>
                                            ) : null}
                                            {
                                                (type!=='cancel'&&item.cancelRefundPrice)?
                                                    <p className="color-orange">
                                                        <p>{__getServerLanguage('CanShengTuiKuan')}</p>
                                                        <p>{item.currencySymbol} {numberWithCommas(toFixedWithCommas(item.cancelRefundPrice,2))}</p>
                                                    </p>
                                                    :
                                                    null
                                            }

                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div className={"flex-item"}>
                                {!item.canUpdateRequire&&isEmptyObject(item.requireResultVO)?null:<FulfillmentDisplay requireResultVO={item.requireResultVO}
                                                                                              refresh={()=>this.refresh()}
                                                                                              styleName={"mr_8"} poItem={item}/>}
                                {item.goodsPicList&&item.goodsPicList.length>0&&<PicturePreview list={item.goodsPicList}
                                                                                                     size={80}
                                                                                                     title={Lang({id: 'BaoZhuangLiuMianTu', default: '包装六面图'})}
                                                                                                    styleName={"mr_8 wrapPicturePreview"}
                                                                                                     expand={expandSixPicture} />}

                                {item.prenatalSamplesPics&&item.prenatalSamplesPics.length>0&&<PicturePreview list={item.prenatalSamplesPics} moreNum={4} title={Lang({id: 'ChanQianYang', default: '产前样'})} styleName={"mr_8 wrapPicturePreview"} />}
                                {item.qualityTestPicList&&item.qualityTestPicList.length>0&&<PicturePreview list={item.qualityTestPicList} moreNum={4} title={Lang({id: 'ZhiJianTuPian', default: '质检图片'})} styleName={"wrapPicturePreview"} />}
                            </div>
                            {/*{showCancleRemark&&item.remark}*/}
                            {showCancleRemark&&item.remark&&<div className={'cancelRemark'}>
                                <div className={'title'}><span className="icon iconfont icon-remark"></span>{Lang({id: 'QuXiaoBeiZhu', default: '取消备注'})}</div>
                                {item.remark}
                                </div>}
                        </div>
                    </div>
                </td>
            </tr>)
        })
        return children;
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            list: nextProps.list || [],
        });
    }
    render() {
        let { type, model,expandSixPicture,showCancleRemark } = this.props;
        let { list } = this.state;
        return (
            <div className="poGoods-list-wrap table-content">
            <table width={'100%'}>
                    <tbody>
                    <tr className={'column-th'}>
                    <td>{Lang({id: 'ShangPinXinXi', default: '商品信息'})}</td>
                    <td className={'widthPrice'}>{Lang({id: 'ShangPinLeiXing', default: '商品类型'})}</td>
                    <td className={'widthNum'}>{Lang({id: 'DanJia', default: '单价'})}</td>
                    <td className={'widthBoxNum'}>{Lang({id: 'XiangShu', default: '箱数'})}</td>
                    <td className={'widthTotal'}>{Lang({id: 'JinE', default: '金额'})}</td>
                    </tr>
                        {this.getItemList(list,model,type,expandSixPicture,showCancleRemark)}
                    </tbody>
            </table>
    </div> );
    }
}

List.defaultProps = {
    //类型 ，cancel（已取消）
    type: "",
    list: [],
    //po单头数据
    model: {},
    //回调
    callBack: function () {},
    expandSixPicture: true, //是否展开六面图
    showCancleRemark: false, //是否 显示备注
};

List.propTypes = {};
export default List;
